import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stage: '',
    loadingProgress: 0,
    scrollProgress: 0,
    sceneProgress: 0,
    sceneDisplayMode: 1,
    usdz: ''
  },
  mutations: {
    setStage: (state, payload) => {
      const { stage } = payload
      state.stage = stage
    },
    setLoadingProgress: (state, payload) => {
      const { progress } = payload
      state.loadingProgress = progress
    },
    setSceneProgress: (state, payload) => {
      const { progress } = payload
      state.sceneProgress = progress
    },
    setScrollProgress: (state, payload) => {
      const { progress } = payload
      state.scrollProgress = progress
    },
    setSceneDisplayMode: (state, payload) => {
      const { mode } = payload
      state.sceneDisplayMode = mode
    },
    setUSDZ: (state, payload) => {
      const { usdz } = payload
      state.usdz = usdz
    }
  },
  actions: {
  },
  modules: {
  }
})
